import logo from "./logo.png";
import supplier1 from "./supplier1.png";
import supplier2 from "./supplier2.png";
import supplier3 from "./supplier3.png";
import loadingIcon from "./loadingIcon.svg";
import tooltipIcon from "./tooltipIcon.svg";

// eslint-disable-next-line
export default { logo, supplier1, supplier2, supplier3, loadingIcon, tooltipIcon };
